module.exports = __webpack_public_path__ + "static/databg-34a7abeda03c4110046824eab1451db3.png";